import { Div, Span } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class ToDo extends Div
{
    constructor(...content: appendable[])
    {
        super();
        this.Background("lightyellow").PositionRelative()
        .Padding(12).Border(2, "#ddd").BorderStyle("dashed").BorderRadius(4)
        .MarginTop(16)//.Italic()//.Bold()
        this.Append(
            // new Span("⚡").FontSize(32).DisplayInlineBlock(), 
            new Span("⚡").FontSize(34).PositionAbsolute().Top(-22).Left(-22), 
            new Div().MarginLeft(8)//.WidthPercent(80)
            .TextAlignLeft().Append(...content).DisplayInlineBlock());
    }
}
